<template>
  <div class="col-12 connections py-4 mb-4">
    <template v-if="connectionDirectors?.length">
      <div class="connections-list-container">
        <div
          class="connections-list"
          v-for="(person, personIndex) in connectionDirectors"
          :key="personIndex"
        >
          <!-- ====== DIRECTOR ====== -->
          <div class="connections-list__header">
            <h4 v-if="person?.inn">
              Руководитель
              <a
                href="#"
                class="btn-link"
                @click.prevent="goToCompany(person.inn)"
              >
                {{ person.fio }}
              </a>
            </h4>
            <h4 v-else>Руководитель {{ person.fio }}</h4>
          </div>

          <div class="connections-list__body">
            <template v-if="person.ogrn_other_company_director?.length">
              <div
                class="company-card"
                v-for="(director, idx) in person.ogrn_other_company_director"
                :key="idx"
              >
                <p v-if="director?.inn">
                  {{ idx + 1 }}.
                  <a
                    href="#"
                    class="btn-link"
                    @click.prevent="goToCompany(director.inn)"
                  >
                    {{ director.name }}
                  </a>
                </p>
                <p v-else class="name">{{ idx + 1 }}. {{ director.name }}</p>

                <p class="details">
                  <span>ИНН: </span>{{ director.inn }} | <span>ОГРН: </span
                  >{{ director.ogrn }} | <span>Дата регистрации: </span
                  >{{ formatDate(director.registration_date) }} |
                </p>

                <p class="activity">
                  <span>Основной вид деятельности:</span>
                  {{ director.okved }}
                </p>
              </div>
            </template>

            <template v-else>
              <p class="text-muted mb-0">Нет данных</p>
            </template>
          </div>

          <!-- ====== FOUNDER ====== -->
          <div class="connections-list__header mt-3">
            <h4 v-if="person?.inn">
              Учредитель
              <a
                href="#"
                class="btn-link"
                @click.prevent="goToCompany(person.inn)"
              >
                {{ person.fio }}
              </a>
            </h4>
            <h4 v-else>Учредитель {{ person.fio }}</h4>
          </div>

          <div class="connections-list__body">
            <template v-if="person.ogrn_other_company_founder?.length">
              <div
                class="company-card"
                v-for="(founder, idx) in person.ogrn_other_company_founder"
                :key="idx"
              >
                <p v-if="founder?.inn">
                  {{ idx + 1 }}.
                  <a
                    href="#"
                    class="btn-link"
                    @click.prevent="goToCompany(founder.inn)"
                  >
                    {{ founder.name }}
                  </a>
                </p>
                <p v-else class="name">{{ idx + 1 }}. {{ founder.name }}</p>

                <p class="details">
                  <span>ИНН: </span>{{ founder.inn }} | <span>ОГРН: </span
                  >{{ founder.ogrn }} | <span>Дата регистрации: </span
                  >{{ formatDate(founder.registration_date) }} |
                </p>

                <p class="activity">
                  <span>Основной вид деятельности:</span>
                  {{ founder.okved }}
                </p>
              </div>
            </template>

            <template v-else>
              <p class="text-muted mb-0">Нет данных</p>
            </template>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <p class="text-center">Нет данных</p>
    </template>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import moment from "moment";

export default defineComponent({
  name: "ConnectionDirectors",
  props: {
    connectionDirectors: Array,
  },
  setup() {
    const router = useRouter();
    const goToCompany = (inn) => {
      router.push("/counter-parties/" + inn);
    };

    const formatDate = (date) => {
      if (!date) return "—";
      return moment(date).format("DD.MM.YYYY");
    };

    return { formatDate, goToCompany };
  },
});
</script>
